import { Button, Checkbox, Col, DatePicker, Form, Modal, notification, Row, Select, Table } from "antd";
import { useEffect, useState } from "react";
import { get_dimensions, get_metrics, getAudiences } from "services/api.service";
import { getAttributeValues } from "services/ManageCustomerBase";
import dayjs from 'dayjs';
import { customerAnalysisReport } from "services/phanTichTapKhachHang";
import { useDispatch } from "react-redux";
import { setAppLoading } from "app/slices/appSlice";
import { exportTableToExcel, formatNumber, isNumber, toNumber } from "helpers";
import ToastHelper from "general/helpers/ToastHelper";
import CreateAudienceModal from "components/CreateAudienceModal";

// Metric "Người dùng" - metric duy nhất được phép tạo tập khách hàng từ báo cáo này
const METRIC_ID_NGUOI_DUNG = 1;

export default function PhanTichTapKhachHang() {

    const [form] = Form.useForm();
    const [formBoLoc] = Form.useForm();
    const [formBang] = Form.useForm();

    const [boLoc, setBoLoc] = useState([]);

    const dispatch = useDispatch();

    // const [queries, setQueries] = useState({});

    const [options, setOptions] = useState({});

    const [metrics, setMetrics] = useState([]);
    const [dimensions, setDimenstions] = useState([]);

    const [initialValues, setInitialValues] = useState({});

    const [isOpenModal, setIsOpenModal] = useState(false);

    const [audiences, setAudiences] = useState([]);
    const [dataExport, setDataExport] = useState({});

    const [isSubmitEnabled, setIsSubmitEnabled] = useState(true);

    // Điều kiện lọc đang dựng nên bảng hiện tại, dùng lại khi tạo tập khách hàng
    const [lastQuery, setLastQuery] = useState(null);

    const [isOpenAudienceModal, setIsOpenAudienceModal] = useState(false);
    const [isCreatingAudience, setIsCreatingAudience] = useState(false);
    const [isProcessingAudience, setIsProcessingAudience] = useState(false);

    function handleClose() {
        setIsOpenModal(false);
    }

    const [columns, setColumns] = useState([]);
    const [fixedColumns, setFixedColumns] = useState([]);
    const [dataTable, setDataTable] = useState([]);
    const [colSpan, setColSpan] = useState(1);

    function set_sorter(a, b, name) {
        if (isNumber(a?.[name])) {
            return toNumber(a?.[name]) - toNumber(b?.[name]);
        }

        const regex = /^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[0-2])\/(\d{4})$/;

        if (regex.test(a?.[name])) {
            const [aDay, aMonth, aYear] = a?.[name].split('/').map(Number);
            const [bDay, bMonth, bYear] = b?.[name].split('/').map(Number);
            return new Date(aYear, aMonth - 1, aDay) - new Date(bYear, bMonth - 1, bDay);
        }
        return false;
    }

    function isSortable(type, id) {
        if (type == "dimension" && id != 1)
            return false;
        return true;
    }

    function converData(data) {

        const lengthCol = data?.statistics?.[0]?.filter(item => item.type == "dimension")?.length || 1;

        setColSpan(lengthCol);

        const columnstmp = Object.keys(data.statistics[0] || {}).map(key => {
            const { name, type, id } = data.statistics[0][key];
            return {
                title: name, dataIndex: name,
                width: 100,
                sorter: isSortable(type, id) ? (a, b) => set_sorter(a, b, name) : undefined,
            };
        });

        setColumns(columnstmp);

        let tmp = [];

        for (let i = 0; i < data.statistics.length; i++) {
            const value = data.statistics[i].reduce((acc, item) => {
                acc[item.name] = formatNumber(item.value);
                acc.type = item.type;
                acc.id = item.id;
                acc.key = i;
                return acc;
            }, {});
            tmp.push(value)
        }

        setDataTable(tmp);
        setDataExport(data);
        setFixedColumns(data.total);
    }

    const checkSelections = () => {

        const selectedDimensions = dimensions.some(item => formBang.getFieldValue(`dimension-${item.id}`));
        const selectedMetrics = metrics.some(item => formBang.getFieldValue(`metric-${item.id}`));

        setIsSubmitEnabled((!selectedDimensions || !selectedMetrics) ? false : true);
    };


    useEffect(() => {

        async function refetchData() {
            dispatch(setAppLoading(true));
            const dataMetrics = await get_metrics(13);

            let filter = [];

            let queries = {};

            const dataDimension = await get_dimensions(13);

            const array = dataDimension.data.data;

            let dimensions = [];
            let metrics = [];

            let obj = {};
            let obj1 = {};

            const promises = array.map(element => {
                if (element?.is_default == 1 || element?.is_default == true) {
                    dimensions.push(element?.id);
                    obj[element?.key] = true;
                    obj1[`dimension-${element?.id}`] = true;
                    filter.push(element);
                    return getAttributeValues(element?.key).then(result => {
                        setOptions(prev => ({ ...prev, [element?.key]: result.data.data.map(item => ({ value: item.value, label: item.name })) }));
                    }).catch(error => {
                        console.log(error);
                    });
                }
                return null;
            });

            Promise.all(promises).then(() => {
                setBoLoc(filter);
                setInitialValues(obj);
                formBang.setFieldsValue(obj1);
            });


            const dataAudience = await getAudiences();
            const audienceIds = dataAudience?.data?.data.map(item => ({ value: item.id, label: item.name })) || [];

            setAudiences(audienceIds);

            formBoLoc.setFieldsValue({ audienceIds: null });

            filter.map(item => {
                if (item.data_type == 3) {

                    const fomatTime = dayjs(new Date()).format('DD/MM/YYYY');
                    queries[item.param] = fomatTime;
                } else {
                    queries[item.param] = [];
                }
            });

            queries.audienceIds = [];

            const initialQueries = Object.assign({}, queries, {
                metricIds: [METRIC_ID_NGUOI_DUNG],
                dimensionIds: dimensions.map(item => Number(item))
            });

            const dataTable = await customerAnalysisReport(initialQueries);

            setLastQuery(initialQueries);

            converData(dataTable?.data?.data);

            setMetrics(dataMetrics.data.data || []);
            setDimenstions(dataDimension.data.data || []);

            dispatch(setAppLoading(false));
        }

        refetchData();
    }, []);

    async function handleSubmit() {

        if (!isSubmitEnabled) {
            ToastHelper.showError("Dimension hoặc Metrics không được để trống!");
            return;
        }

        dispatch(setAppLoading(true));
        // kiem tra xem no la loai thoi gian hay khong
        const selectedDateValues = dimensions.filter(item => item.data_type == 3).map(item => item.param);
        const selectedDateAndMonthValues = dimensions.filter(item => item.data_type == 4).map(item => item.param);
        const selectedKeyRangePickerValues = dimensions.filter(item => item.data_type == 3).map(item => item.key);

        const dataBoLoc = formBoLoc.getFieldsValue();

        const dataBang = formBang.getFieldsValue();

        let obj = {};

        Object.keys(dataBoLoc).map(key => {
            if (selectedDateAndMonthValues.includes(key)) {
                const listDate = dataBoLoc[key].map(item => dayjs(item).format('DD-MM'));

                obj[key] = listDate;
            }
            else if (selectedKeyRangePickerValues.includes(key)) {
                const params = dimensions.filter(item => item.key == key).map(item => item.param)[0];
                if (dataBoLoc[key]) {

                    params.forEach((e, index) => {

                        const time = dataBoLoc[key][index];
                        const formatDate = dayjs(time).format("YYYY-MM-DD");

                        obj[e] = formatDate;
                    });
                } else {
                    params.forEach(e => {
                        // obj[e] = null;
                    });
                }
            }
            else if (selectedDateValues.includes(key)) {

                const fomatTime = dayjs(dataBoLoc[key]).format('DD/MM/YYYY');
                obj[key] = fomatTime;
            } else {

                if (key == "audienceIds") {
                    if (dataBoLoc[key]) {
                        // console.log(dataBoLoc[key])
                        obj[key] = [dataBoLoc[key]];
                    } else {
                        obj[key] = [];
                    }
                } else if (dataBoLoc[key]) {
                    obj[key] = dataBoLoc[key];
                } else {
                    obj[key] = [];
                }
            }
        });

        let dimension = [];
        let metric = [];

        Object.keys(dataBang).map(key => {
            const temp = key.split("-");
            const value = dataBang[key];

            if (temp[0] == "dimension") {
                if (value == true) {
                    dimension.push(parseInt(temp[1]));
                }
            } else {
                if (value == true) {
                    metric.push(parseInt(temp[1]));
                }
            }
        });

        const tmp = Object.assign({}, obj, { metricIds: metric, dimensionIds: dimension.map(item => Number(item)) })

        // console.log(tmp)

        const data = await customerAnalysisReport(tmp);

        setLastQuery(tmp);

        converData(data?.data?.data)

        dispatch(setAppLoading(false));
    }

    async function handleCreateAudience(name, description) {

        if (!lastQuery) {
            ToastHelper.showError("Chưa có dữ liệu báo cáo để tạo tập khách hàng!");
            return;
        }

        setIsCreatingAudience(true);
        try {
            const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

            // Backend chỉ tạo tập khi request có metric "Người dùng"
            const currentMetricIds = lastQuery?.metricIds || [];
            const metricIds = currentMetricIds.includes(METRIC_ID_NGUOI_DUNG)
                ? currentMetricIds
                : [...currentMetricIds, METRIC_ID_NGUOI_DUNG];

            const res = await customerAnalysisReport(Object.assign({}, lastQuery, {
                metricIds: metricIds,
                create_audience: 1,
                audience_name: name,
                description: description,
                userId: user?.id
            }));

            if (res?.data?.code === 200) {
                ToastHelper.showSuccess("Hệ thống đang tạo tập khách hàng. Vui lòng kiểm tra lại sau ít phút.");
                setIsOpenAudienceModal(false);
                setIsProcessingAudience(true);
            } else {
                ToastHelper.showError(res?.data?.message || "Có lỗi xảy ra");
            }
        } catch (error) {
            console.log(error);
            ToastHelper.showError(error?.response?.data?.showMessage || error?.response?.data?.message || "Có lỗi xảy ra");
        } finally {
            setIsCreatingAudience(false);
        }
    }


    const disabledDate = (current) => {
        // Can not select days before today and today
        return current && current > dayjs().endOf('day');
    };

    return (
        <div className="container-fluid">
            <Modal
                title={<div style={{ textAlign: 'center', fontSize: "20px" }}>{"Chọn bộ lọc"}</div>}
                width={1000}
                open={isOpenModal}
                onCancel={handleClose}
                onClose={handleClose}
                onOk={() => form.submit()}
                cancelButtonProps={{ hidden: true }}
            >
                <Form
                    form={form}
                    initialValues={initialValues}
                    onFinish={(values) => {
                        const allFalse = Object.values(values).every(value => (value !== true));
                        if (allFalse) {
                            notification.error({ message: "Bộ lọc không được để trống" });
                        } else {
                            const selectedValues = Object.keys(values).filter(key => values[key] === true);

                            const typeDate = dimensions.filter(item => item.data_type == 3 || item.data_type == 4).map(item => item.key);

                            const filter = dimensions.filter(item => selectedValues.includes(item.key));


                            const promises = filter.map(element => {
                                if (!options[element.key] && !typeDate.includes(element.key)) {
                                    // date khong goi api
                                    // if (!options[element.key]) {
                                    return getAttributeValues(element?.key).then(result => {
                                        setOptions(prev => ({ ...prev, [element?.key]: result.data.data.map(item => ({ value: item.value, label: item.name })) }));
                                    }).catch(error => {
                                        console.log(error);
                                    });
                                }
                                return null; // Return null for non-default elements
                            });

                            setBoLoc(filter);

                            setIsOpenModal(false);
                        }
                    }}
                >
                    <Row gutter={[12, 12]} className="flex items-center">
                        {dimensions && dimensions.map((item, index) => {
                            return <Col key={index} span={8} className="flex">
                                <Form.Item
                                    name={`${item?.key}`}
                                    valuePropName="checked"
                                >
                                    <Checkbox>
                                        {item?.name}
                                    </Checkbox>
                                </Form.Item>
                            </Col>
                        })}
                    </Row>

                </Form>
            </Modal>
            <CreateAudienceModal
                visible={isOpenAudienceModal}
                onCancel={() => setIsOpenAudienceModal(false)}
                onCreate={handleCreateAudience}
                loading={isCreatingAudience}
            />
            <div className="card card-body flex gap-3">
                <div className='flex'>
                    <div className='w-full'>
                        <h2>PHÂN TÍCH TẬP KHÁCH HÀNG</h2>
                    </div>
                    <div className='w-full flex justify-content-end gap-3'>
                        <Button type="primary"
                            onClick={() => {
                                if (dataExport?.statistics?.length > 1000000) {
                                    ToastHelper.showError("Dữ liệu vượt quá 1.000.000 dòng, không thể xuất file!");
                                    return;
                                }
                                const selectedId = formBoLoc.getFieldValue('audienceIds');
                                const selectedAudience = audiences.find(a => a.value === selectedId);
                                const name = selectedAudience ? selectedAudience.label : "TatCaKhachHang";
                                const filename = `${name}_${dayjs().format('DD-MM-YYYY')}`;
                                exportTableToExcel(dataExport, colSpan, filename);
                            }}
                        >Export</Button>
                    </div>
                </div>
                <div className="flex flex-col gap-5">
                    <Form
                        form={formBoLoc}
                        onFinish={(values) => {
                            handleSubmit();
                        }}
                    >
                        <Row className="flex items-end" gutter={[12, 12]}>
                            <Col className="flex flex-col" span={4}>
                                <div>
                                    Tập khách hàng
                                </div>
                                <Form.Item
                                    name="audienceIds"
                                    style={{ padding: "0 0 0 0", margin: "0 0 0 0" }}
                                >
                                    <Select
                                        showSearch
                                        filterOption={(input, option) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        options={[{ label: "Tất cả khách hàng", value: null }, ...audiences]}
                                    />
                                </Form.Item>
                            </Col>

                            <Col>
                                <Button type="primary"
                                    onClick={() => {
                                        setIsOpenModal(true);
                                    }}
                                >
                                    Thêm bộ lọc
                                </Button>
                            </Col>
                        </Row>

                        <Row gutter={[12, 12]}>
                            {
                                boLoc && boLoc.map((item, index) => {
                                    return <Col
                                        xs={24}
                                        md={12}
                                        xl={6}
                                        key={index}>
                                        <div>
                                            {item.name}
                                        </div>
                                        {
                                            Array.isArray(item.param) ? <Form.Item
                                                name={item.key}
                                            >
                                                {item.data_type == 3 &&
                                                    <DatePicker.RangePicker
                                                        className="w-full"
                                                        format={"DD/MM/YYYY"}
                                                        placeholder={["Ngày bắt đầu", "Ngày kết thúc"]}
                                                        disabledDate={disabledDate}
                                                    />}
                                            </Form.Item> :
                                                <Form.Item
                                                    name={item.param}
                                                >
                                                    {item.data_type == 3 ?
                                                        <DatePicker
                                                            className="w-full"
                                                            format={"DD/MM/YYYY"}
                                                        /> : item.data_type == 4 ?
                                                            <DatePicker
                                                                multiple
                                                                maxTagCount="responsive"
                                                                className="w-full"
                                                                format={"DD/MM"}
                                                                placeholder={`Chọn ${item.name}`}
                                                            /> :
                                                            <Select
                                                                className="w-full"
                                                                options={options[item?.key]}
                                                                mode="multiple"
                                                                placeholder="Tất cả"
                                                                allowClear
                                                            />}
                                                </Form.Item>
                                        }

                                    </Col>
                                })
                            }
                        </Row>
                        <Row>
                            <Button
                                type="primary"
                                onClick={() => {
                                    formBoLoc.submit();
                                }}
                            >
                                Áp dụng
                            </Button>
                        </Row>
                    </Form>

                    <Row justify="space-between">
                        <Col span={19}>
                            <Table
                                columns={columns}
                                dataSource={dataTable}
                                pagination={{
                                    defaultPageSize: 20,
                                    showSizeChanger: true,
                                    pageSizeOptions: ["10", "20", "50", "100"],
                                }}
                                scroll={{ x: 'max-content', y: 500 }}
                                summary={() => (
                                    <Table.Summary fixed>
                                        <Table.Summary.Row>
                                            <Table.Summary.Cell index={0} colSpan={colSpan}><b>Tổng</b></Table.Summary.Cell>
                                            {
                                                fixedColumns.map((item, index) => {
                                                    // Cùng id với metric nhưng name có "%" là ô tỉ lệ, không phải ô tổng số người dùng
                                                    const isNguoiDungTotal = item.id === METRIC_ID_NGUOI_DUNG
                                                        && !String(item.name).includes("%");
                                                    return (
                                                        <Table.Summary.Cell key={index} index={index + 1}>
                                                            <div className="flex justify-between items-center w-full">
                                                                <span className="whitespace-nowrap">{formatNumber(item.value)}</span>
                                                                {isNguoiDungTotal && (
                                                                    <Button
                                                                        type="primary"
                                                                        size="small"
                                                                        className="ml-2"
                                                                        onClick={() => setIsOpenAudienceModal(true)}
                                                                        disabled={isProcessingAudience}
                                                                        loading={isProcessingAudience}
                                                                    >
                                                                        {isProcessingAudience ? "Đang tạo..." : "Tạo tập KH"}
                                                                    </Button>
                                                                )}
                                                            </div>
                                                        </Table.Summary.Cell>
                                                    )
                                                })
                                            }
                                        </Table.Summary.Row>
                                    </Table.Summary>
                                )}
                            />
                        </Col>
                        <Col span={4}>
                            <Form className="flex flex-col gap-3 w-full"
                                form={formBang}
                                onFinish={(values) => {
                                    // refeshTable(values);

                                    handleSubmit();
                                }}
                                initialValues={{ "metric-1": true, }}
                            >
                                <div>
                                    <div>
                                        <b>Dimension</b>
                                    </div>
                                    {dimensions && dimensions.map((item, index) => {
                                        return <Form.Item
                                            style={{ padding: "0 0 0 0", margin: "0 0 0 0" }}
                                            name={`dimension-${item?.id}`}
                                            valuePropName="checked"
                                            key={index}
                                        >
                                            <Checkbox
                                                onChange={() => {
                                                    checkSelections();
                                                }}
                                            // defaultChecked={item?.is_default == 1 ? true : false}
                                            >
                                                {item?.name}
                                            </Checkbox>
                                        </Form.Item>
                                    })}
                                </div>
                                <div>
                                    <div>
                                        <b>
                                            Metrics
                                        </b>
                                    </div>
                                    {metrics && metrics.map((item, index) => {
                                        return <Form.Item
                                            key={index}
                                            style={{ padding: "0 0 0 0", margin: "0 0 0 0" }}
                                            name={`metric-${item?.id}`}
                                            valuePropName="checked"
                                        >
                                            <Checkbox
                                                onChange={() => {
                                                    checkSelections();
                                                }}
                                            // defaultChecked={item?.id == 1 ? true : false}
                                            >
                                                {item?.name}
                                            </Checkbox>
                                        </Form.Item>
                                    })}
                                </div>
                                <div className="w-full flex items-center justify-center">
                                    <Form.Item>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            disabled={!isSubmitEnabled}
                                        >
                                            Áp dụng
                                        </Button>
                                    </Form.Item>
                                </div>
                            </Form>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}